import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { ArtworkList } from '../components/ArtworksListView';
import { HStack } from '@sheridan-prize/ui';
import { Link } from '../components/Link';
import { MaterialSymbol, StateLayer } from '@moonjellydigital/react-components';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: Index,
});

function Index() {
  return (
    <>
      <SpSidebar />
      <Pane classes={'sp-main'} tag="main">
        <HStack gap="s4" align="center" padBlockEnd="s4">
          <h1 style={{ maxWidth: 'max-content', marginBlockStart: '0' }}>
            All Artworks
          </h1>
          <Link
            to="/artworks/add"
            className={'mjd-button mjd-button_filled'}
            style={{ maxWidth: 'max-content', justifyContent: 'flex-start' }}
          >
            <StateLayer tag="span" />
            <MaterialSymbol icon="add" /> Add Artwork
          </Link>
        </HStack>
        <ArtworkList />
      </Pane>
    </>
  );
}
